import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AngularSvgIconModule} from "angular-svg-icon";
import {AppDataService} from "../../../service/app_data.service";
import {EventBusService} from "../../../service/event-bus.service";
import {RegisterProductsLatamComponent} from "./register-products-latam.component";
import {RegisterProductsLatamRoutingModule} from "./register-products-latam-routing.module";


@NgModule({
  declarations: [RegisterProductsLatamComponent],
    imports: [
        CommonModule,
        RegisterProductsLatamRoutingModule,
        ReactiveFormsModule,
        TranslateModule,
        FormsModule,
        AngularSvgIconModule.forRoot()
    ],
    providers: [
        TranslateService,
        AppDataService,
        EventBusService,
    ]
})
export class RegisterProductsLatamModule { }
